import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

import ProtectedRoute from "./auth/protectedRoute";
import routes from "./config/routes";

// Lazy loading de toutes les pages
// Réduit le bundle initial en chargeant chaque page à la demande
const Login                = lazy(() => import("./login"));
const Dashboard            = lazy(() => import("./features/dashboard/pages/dashboard"));
const Orders               = lazy(() => import("./features/orders/pages/orders"));
const Stock                = lazy(() => import("./features/stock/pages/stock"));
const Inventory            = lazy(() => import("./features/inventory/pages/inventory"));
const Replenishments       = lazy(() => import("./features/replenishment/pages/replenishment"));
const CreateOrder          = lazy(() => import("./features/orders/pages/neworder"));
const CreateReplenishment  = lazy(() => import("./features/replenishment/pages/newreplenish"));
const CreateDeclination    = lazy(() => import("./features/replenishment/pages/newdeclination"));
const CreateProduct        = lazy(() => import("./features/replenishment/pages/newproduct"));
const Contacts             = lazy(() => import("./features/contacts/pages/contacts"));
const Missions             = lazy(() => import("./features/missions/pages/missions"));
const RolePermissionsAdmin = lazy(() => import("./features/users/pages/roleManagement"));
const UserManagement       = lazy(() => import("./features/users/pages/userManagement"));
const Packings             = lazy(() => import("./features/shipments/pages/packings"));
const Locations            = lazy(() => import("./features/locations/pages/locations"));
const Shipment             = lazy(() => import("./features/shipments/pages/shipment"));
const StoreSyncPage        = lazy(() => import("./features/shop/pages/storeSyncPage"));

const PageLoader = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight="60vh"
    aria-label="Chargement de la page"
  >
    <CircularProgress />
  </Box>
);

const AppRoutes = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* PUBLIC */}
        <Route path={routes.LOGIN} element={<Login />} />

        {/* PROTÉGÉES */}
        <Route path={routes.DASHBOARD}   element={<ProtectedRoute element={Dashboard} />} />
        <Route path={routes.ORDERS}      element={<ProtectedRoute element={Orders} />} />
        <Route path={routes.STOCK}       element={<ProtectedRoute element={Stock} />} />
        <Route path={routes.INVENTORY}   element={<ProtectedRoute element={Inventory} />} />
        <Route path={routes.REPLENISHMENT} element={<ProtectedRoute element={Replenishments} />} />
        <Route path={routes.NEW_ORDER}     element={<ProtectedRoute element={CreateOrder} />} />
        <Route path={routes.NEW_REPLENISH} element={<ProtectedRoute element={CreateReplenishment} />} />
        <Route path={routes.NEW_DECLINATION} element={<ProtectedRoute element={CreateDeclination} />} />
        <Route path={routes.NEW_PRODUCT} element={<ProtectedRoute element={CreateProduct} />} />
        <Route path={routes.CONTACTS}    element={<ProtectedRoute element={Contacts} />} />
        <Route path={routes.MISSIONS}    element={<ProtectedRoute element={Missions} />} />
        <Route path={routes.PACKINGS}    element={<ProtectedRoute element={Packings} />} />
        <Route path={routes.LOCATIONS}   element={<ProtectedRoute element={Locations} />} />
        <Route path={routes.SHIPMENT}    element={<ProtectedRoute element={Shipment} />} />
        <Route path={routes.SHOP}        element={<ProtectedRoute element={StoreSyncPage} />} />

        {/* Accès restreint par rôle */}
        <Route
          path={routes.PERMISSIONS_ADMIN}
          element={
            <ProtectedRoute
              element={RolePermissionsAdmin}
              allowedRoles={["Admin", "SuperAdmin", "Manager"]}
            />
          }
        />
        <Route
          path={routes.USERS}
          element={
            <ProtectedRoute
              element={UserManagement}
              allowedRoles={["Admin", "SuperAdmin", "Manager"]}
            />
          }
        />

        {/* Catch-all */}
        <Route path="*" element={<Navigate to={routes.DASHBOARD} replace />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
